import {Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {BaseDialogComponent} from '../base-dialog/base-dialog.component';

@Component({
  selector: 'app-max-participants-dialog',
  imports: [TranslocoPipe, BaseDialogComponent],
  templateUrl: './max-participants-dialog.component.html',
})
export class MaxParticipantsDialogComponent {
  visible = input<boolean>(false);
  maxAllowedParticipants = input<number>(0);
  visibleChange = output<boolean>();

  close(): void {
    this.visibleChange.emit(false);
  }
}
